import { gql } from 'graphql.macro';

/**
 * DD-3687: the historical archive is read-only, so this folder has queries and
 * no mutations. Both documents are hand-written — the app has no GraphQL
 * codegen.
 */
export const searchHistoricalOrdersTemplate = gql`
    query HistoricalOrders($value: SearchString, $dateFrom: Date, $dateTo: Date, $limit: Int, $offset: Int) {
        historicalOrders(value: $value, dateFrom: $dateFrom, dateTo: $dateTo, limit: $limit, offset: $offset) {
            rows {
                _id
                orderNumber
                orderDate
                customerName
                labName
                patientReference
                totals {
                    inclVat
                    currency
                }
            }
            hasMore
        }
    }
`;

export const getHistoricalOrderTemplate = gql`
    query HistoricalOrder($id: MongoDbObjectId!) {
        historicalOrder(id: $id) {
            _id
            orderNumber
            orderDate
            deliveryDate
            customerName
            deliveryDestinationName
            labName
            patientReference
            status
            totals {
                exclVat
                vat
                inclVat
                currency
            }
            lines {
                type
                code
                description
                quantity
                unit
                unitPrice
                vatRate
                vatAmount
                lineTotal
            }
            messages {
                sentAt
                senderName
                senderSide
                text
            }
            attachments {
                _id
                fileName
                size
            }
            comments
            extraDetails {
                label
                value
            }
            sourceSystem
            importBatchId
            importedAt
        }
    }
`;

export const historicalOrderFileDownloadUrlTemplate = gql`
    query HistoricalOrderFileDownloadUrl($historicalOrderId: MongoDbObjectId!, $fileId: MongoDbObjectId!) {
        historicalOrderFileDownloadUrl(historicalOrderId: $historicalOrderId, fileId: $fileId)
    }
`;
